/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Protein_WordsInputs */

const en_us2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`protein food diet meals`)
};

const pt_br2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proteina alimentacao dieta refeicoes comida`)
};

const es_419_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proteina alimentacion dieta comidas comida`)
};

const pt_pt2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proteina alimentacao dieta refeicoes comida`)
};

const fr_fr2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proteines alimentation regime repas nourriture`)
};

const de_de2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`protein eiweiß ernährung diät mahlzeiten essen`)
};

const it_it2_search_field_protein_words = /** @type {(inputs: Search_Field_Protein_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proteine alimentazione dieta pasti cibo`)
};

/**
* | output |
* | --- |
* | "protein food diet meals" |
*
* @param {Search_Field_Protein_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_protein_words = /** @type {((inputs?: Search_Field_Protein_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Protein_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_protein_words(inputs)
	if (locale === "es-419") return es_419_search_field_protein_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_protein_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_protein_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_protein_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_protein_words(inputs)
	return en_us2_search_field_protein_words(inputs)
});
export { search_field_protein_words as "search.field_protein_words" }